/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-15 16:19:29
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-04-15 23:59:01
 * @FilePath: /zeelool-nextjs/src/providers/auth-provider.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { useStore } from './app-store-provider';

interface AuthContextType {
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType>({ isAuthenticated: false });

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const token = useStore((state) => state.token);
  const authValue = !!token;

  return (
    <AuthContext.Provider value={{ isAuthenticated: authValue }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
